<template>
  <div class="buddy-select-button" :class="[buddy.selected ? 'selected' : '', interactable ? 'interactable' : '']" @click="buddyClicked">
    <div class="buddy-image-container d-flex align-items-center justify-content-center">
      <img :src=buddy.imageUrl :alt="buddy.name" v-if="buddy.avatar"/>
      <img src="@/assets/image/avatar/avatar_temp.png" alt="Buddy image" v-else/>
      <BuddyAvatar :buddy="buddy"></BuddyAvatar>
    </div>
    <div class="buddy-info-container">
      <div class="title">
        <span>{{ buddy.buddyConfig.className }}</span>
        <span class="edit-button" :class="[showEditButton ? 'showEdit' : '']">
          <button class="btn" type="button" @click="editClicked"><i class="fas fa-edit"></i></button>
        </span>
      </div>

      <div class="school">
        {{ buddy.buddyConfig.school.name }}
      </div>

      <div class="xp-bar">
        <div class="level">{{ buddy.level }}</div>
        <div class="bar">
          <div class="fill" :style="fillWidth"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import log from "@/utils/logger";
import BuddyAvatar from "@/components/Common/BuddyAvatar";

export default {
  name: "BuddySelectButton",
  components: { BuddyAvatar },
  props: {
    buddy: Object,
    showEditButton: Boolean,
    interactable: Boolean
  },
  computed: {
    experiencePercentage()
    {
      if (this.buddy.experience === 0) return 0;
      return (this.buddy.experience) / (this.buddy.experience + this.buddy.expNextLevel) * 100
    },
    fillWidth()
    {
      return { "width": this.experiencePercentage + "%" };
    }
  },
  data()
  {
    return {
      expPerLevel: 1000
    }
  },
  methods: {
    buddyClicked()
    {
      if(this.interactable)
      {
        if(!this.buddy.selected)
        {
          log.info("[BuddySelectButton] buddy clicked: %o", this.buddy)
          this.$emit("clicked", this.buddy);
        }
      }
    },
    editClicked(e)
    {
      if(this.interactable)
      {
        e.stopPropagation();
        log.info("[BuddySelectButton] edit buddy clicked: %o", this.buddy)
        this.$emit("editClicked", this.buddy);
      }
    }
  },
  created()
  {
  }
}
</script>

<style lang="scss" scoped>
.buddy-select-button
{

  min-height: 75px;
  box-shadow: $default-shadow;
  border-radius: 5px;
  display: flex;

  color: $font-dark;

  overflow: hidden;

  &.interactable
  {
    cursor: pointer;
  }

  &.selected
  {
    cursor: default;

    .buddy-info-container
    {
      background-color: $primary-blue;
      color: $font-light;
    }

    .buddy-info-container .xp-bar .level
    {
      color: $font-light;
    }

    .buddy-info-container .xp-bar .bar .fill
    {
      background-color: $font-light;
    }

    .buddy-info-container .xp-bar .bar
    {
      background-color: $font-dark;
    }
  }

  .buddy-image-container {
    position: relative;
    min-width: 75px;
    min-height: 75px;
    font-size: 30px;

    aspect-ratio: 1 / 1;

    color: $font-light;
    background-color: $primary-background;

    img
    {
      width: 75px;
      height: 75px;
      object-fit: cover;
      border-radius: 5px 0px 0px 5px;
    }
  }

  .buddy-info-container
  {
    flex: 1 1;
    flex-direction: column;
    padding: 0px 14px;
    min-width: 0px;

    background-color: $soft-highlight;

    .title
    {
      font-size: $title-size;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .school
    {
      font-size: $body-text-size;
      min-width: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .xp-bar
    {
      display: flex;
      align-items: center;
      height: 20px;

      .level
      {
        padding-right: 10px;
        font-weight: bold;
        color: $primary-blue;
      }

      .bar
      {
        flex: 5 5;
        background-color: $medium-highlight;
        height: 5px;
        border-radius: 5px;

        .fill
        {
          background-color: $primary-blue;
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }
    }
  }
}

.edit-button
{
  float: right;
  display: none;
  height: 25px;

  .btn
  {
    color: white;
  }
}

.showEdit
{
  display: block;
}

</style>